import { proposeEventWatcher } from './proposeEvent';

export const postEventSaga = [proposeEventWatcher];

export * from './proposeEvent';
